import React from "react";
import { InlineSkeleton } from "@smartling/react-skeleton";

import * as styles from "./styles.module.css";

function FieldSkeleton() {
    return (
        <div className={styles.fieldWrap}>
            <InlineSkeleton className={styles.label} />
            <InlineSkeleton className={styles.input} />
        </div>
    );
}

export function RegistrationFormSkeleton() {
    return (
        <div data-testid="registrationFormSkeleton" className={styles.container}>
            <FieldSkeleton />
            <FieldSkeleton />
            <FieldSkeleton />
            <FieldSkeleton />
            <FieldSkeleton />
            <InlineSkeleton className={styles.checkbox} aria-label="Loading form" />
            <InlineSkeleton className={styles.button} />
            <InlineSkeleton className={styles.divider} />
            <InlineSkeleton className={styles.button} />
        </div>
    );
}
